import { createI18n } from 'vue-i18n'
import en from './en.json'
import ptBR from './pt-BR.json'

export type Locale = 'pt-BR' | 'en'

const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('locale') : null
const initial: Locale = stored === 'en' || stored === 'pt-BR' ? stored : 'pt-BR'

export const i18n = createI18n({
  legacy: false,
  locale: initial,
  fallbackLocale: 'en',
  messages: { en, 'pt-BR': ptBR },
})

export function setLocale(locale: Locale): void {
  const global = i18n.global
  if ('value' in global.locale) {
    ;(global.locale as { value: Locale }).value = locale
  } else {
    ;(global.locale as unknown as Locale) = locale
  }
  try {
    localStorage.setItem('locale', locale)
  } catch {
    // storage unavailable (private mode) — locale still applies for the session
  }
  document.documentElement.lang = locale
}

export function currentLocale(): Locale {
  const loc = i18n.global.locale
  return ('value' in loc ? (loc as { value: Locale }).value : (loc as unknown as Locale)) ?? 'pt-BR'
}
